















import { getIsTicketCheckVisible } from '@app/utils/config/sportConfig';
import { getFederationComponent } from '@src/federations/getFederationComponent';
import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';
import {
    defineComponent,
    computed,
    defineAsyncComponent,
} from '@vue/composition-api';

import MEBBSummarySkeleton from './MEBBSummarySkeleton.vue';

const stickyConfig = {
    scrollableContentSelector: '.mebb-summary',
    staticHigherContentSelector: '.verification-bar',
    fixedLowerContentSelector: '.ticket-stack__container .ss-chat',
    offset: 26,
};

const MEBBSummary = defineAsyncComponent({
    loader: () => import('@sportOfferFederation/bet-builder/multi-event/components/MEBBSummary.vue'),
    loadingComponent: MEBBSummarySkeleton,
    delay: 0, // needs to be 0 due to width shifts of the main content in desktop view
    suspensible: false,
});

export default defineComponent({
    name: 'MEBBSummaryContainer',
    setup() {
        return {
            stickyConfig,
            isMobile: computed(() => isMobileLayout()),
            isTicketCheckVisible: getIsTicketCheckVisible(),
        };
    },
    components: {
        MEBBSummary,
        MEBBSummaryCompact: () => import('@sportOfferFederation/bet-builder/multi-event/components/MEBBSummaryCompact.vue'),
        CheckTicket: getFederationComponent(() => import('tickets/CheckTicket')),
    },
});
